module.exports = __webpack_public_path__ + "img/dashiji-2002.70448aaa.jpg";